module.exports = __webpack_public_path__ + "icon-marker-green.svg?0ff2e56298ea09c90d13e758c197c6d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-marker-green.svg
// module id = 30
// module chunks = 0